import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {commonFetchListResponse, handleResponseError, ListResponse} from '../../common/api-helpers';
import {QueryLangFilterOperator} from '../../enums/query-lang-filter-operator';
import {SortDirection} from '../../enums/sort-direction';
import {ListFilterFactory} from '../../factories/list-filter.factory';
import {Asset} from '../../models/asset';
import {CommonListFilter} from '../../models/filters/common-list-filter';
import {QueryLangFilterCriterion} from '../../models/filters/query-lang-filter-criterion';
import {AppConfigService} from '../../services/config.service';
import {AutocompleteProvider, AutocompleteProviderConfig} from '../autocomplete';
import {autocompleteAsset} from './asset-autocomplete';

const ASSET_SYMBOL: keyof Asset = 'symbol';

@Injectable()
export class BackofficeAssetService implements AutocompleteProvider<Asset> {

    private assetsUrl: string = this.appConfigService.api['backofficeAssets'];

    constructor(
        private httpClient: HttpClient,
        private appConfigService: AppConfigService
    ) {}

    public getAssets(listFilter: CommonListFilter): Observable<ListResponse<Asset>> {
        return commonFetchListResponse(this.httpClient, this.assetsUrl, listFilter);
    }

    public getAsset(assetId: string): Observable<Asset> {
        return this.httpClient.get<Asset>(`${this.assetsUrl}/${assetId}`).pipe(
            catchError(handleResponseError)
        );
    }

    public getAssetBySymbol(assetSymbol: string): Observable<Asset> {
        const filterBySymbol = new QueryLangFilterCriterion<Asset>({
            fieldNames: ['symbol'],
            operator:   QueryLangFilterOperator.EQ,
            query:      assetSymbol
        });

        const listFilter = ListFilterFactory.createWithSearchFields(
            [filterBySymbol],
            ASSET_SYMBOL,
            SortDirection.ASC,
            20
        );

        return this.getAssets(listFilter).pipe(
            map(listResponse => listResponse.data[0])
        );
    }

    public autocomplete(
        term: string,
        config?: AutocompleteProviderConfig<Asset>
    ): Observable<Asset[]> {
        return autocompleteAsset(
            listFilter => this.getAssets(listFilter),
            term,
            config
        );
    }

}
